import { Stack } from 'expo-router/stack';

export default function ClubLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
